import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState = {
  user: {},
  error: '', // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  authenticated: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.error;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, _action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = '';
      state.loading = false;
      state.errorMsg = false;
    },
    authStatus(state) {
      state.authenticated = false;
    },
    setAuthStatus: (state, action: PayloadAction<boolean>) => {
      state.authenticated = action.payload;
    },
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  authStatus,
  setAuthStatus,
} = loginSlice.actions;

export default loginSlice.reducer;
